import { ProfileId, StepDefinition } from "../../../types/types";

export type FormValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | FormValue[]
  | { [key: string]: FormValue };

export type DealFormData = Record<string, FormValue>;

export type TranslationParams =
  | string
  | Record<string, string | number | boolean | null | undefined>;

export const COMPONENT_PAYMENTS_STEP_ID = "__component_payments__";
export const FINAL_REVIEW_STEP_ID = "__final_review__";

export type DeadlineRule = {
  stage: string;
  offsetDays?: number;
};

// A step of the backend template. Only the optional parts the wizard reads are
// listed: "visible: false" hides a step, "outcomeRegistry" marks the payout
// policies step, "deadlineRules" carries the payment date offsets and
// kind "notes" marks a notes and attachments step.
export type TemplateStep = StepDefinition & {
  visible?: boolean;
  outcomeRegistry?: unknown;
  deadlineRules?: DeadlineRule[];
  kind?: "notes";
};

export type SavedComponentPayment = {
  id?: number;
  component: string;
  paymentTiming: string;
  amount: number;
  dueOn?: string;
  paidOn?: string;
  status?: string;
};

export type ComponentEntry = {
  componentType?: string;
  type?: string;
  component?: string;
  value?: number | string | null;
  amount?: number | string | null;
  price?: number | string | null;
  fundingStage?: string;
  funding_stage?: string;
  paymentTiming?: string;
  payment_timing?: string;
  paymentTimingKey?: string;
  mode?: string;
  componentLabel?: string;
};

export type FieldHelpers = {
  getFormValue: (stepId: string, fieldKey: string) => FormValue;
  updateFieldValue: (stepId: string, fieldKey: string, value: FormValue) => void;
  errors: Record<string, string | undefined>;
  formData: DealFormData;
  availableFighters: Array<{ id: ProfileId; firstName?: string; lastName?: string }>;
  optionsBySource: Record<string, Array<{ key: string; label: string }>>;
  loadingOptionsBySource: Record<string, boolean>;
  isLockedField: (stepId: string, fieldKey: string) => boolean;
  tr: (key?: string, fallbackOrOptions?: TranslationParams) => string;
};
